import { CheckboxInput, FormItem, TextInput } from '@framework/form';
import { Card, Typography } from 'antd';
import React from 'react';
import { useWatch } from 'react-hook-form';

export interface IAsyncServiceActionMessageFormProps {
  name: string;
  show: boolean;
}

export function AsyncServiceActionMessageForm(
  props: IAsyncServiceActionMessageFormProps,
) {
  const { name, show } = props;

  const enableRequestMessage = useWatch({ name: `${name}.enableRequestMessage` }); // prettier-ignore
  const enableSuccessMessage = useWatch({ name: `${name}.enableSuccessMessage` }); // prettier-ignore

  if (!show) {
    return null;
  }

  return (
    <Card size="small" title="Configura messaggi" style={{ marginTop: '8px' }}>
      <Typography.Paragraph>
        È possibile configurare i messaggi mostrati all&apos;utente durante
        l&apos;esecuzione del servizio asincrono così da notificarlo
        dell&apos;andamento della richiesta.
      </Typography.Paragraph>
      <FormItem
        name={`${name}.enableRequestMessage`}
        label="Abilita messaggio richiesta"
      >
        <CheckboxInput name={`${name}.enableRequestMessage`}>
          Mostra all&lsquo;utente un messaggio durante l&lsquo;esecuzione del
          servizio
        </CheckboxInput>
      </FormItem>
      {enableRequestMessage && (
        <FormItem
          name={`${name}.requestMessage`}
          label="Messaggio durante la richiesta"
        >
          <TextInput
            name={`${name}.requestMessage`}
            size="small"
            defaultValue={'Attendere...'}
          />
        </FormItem>
      )}

      <FormItem
        name={`${name}.enableSuccessMessage`}
        label="Abilita messaggio successo"
      >
        <CheckboxInput name={`${name}.enableSuccessMessage`}>
          Mostra all&lsquo;utente un messaggio durante l&lsquo;esecuzione del
          servizio
        </CheckboxInput>
      </FormItem>
      {enableSuccessMessage && (
        <FormItem name={`${name}.successMessage`} label="Messaggio di successo">
          <TextInput
            name={`${name}.successMessage`}
            size="small"
            defaultValue={'Successo'}
          />
        </FormItem>
      )}
    </Card>
  );
}
